import { LocationType } from '../location-type';
var ItemLocation = /** @class */ (function () {
    function ItemLocation(_name, _requirements, _locationType, _left, _top) {
        this._name = _name;
        this._requirements = _requirements;
        this._locationType = _locationType;
        this._left = _left;
        this._top = _top;
    }
    Object.defineProperty(ItemLocation.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemLocation.prototype, "requirements", {
        get: function () {
            return this._requirements;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemLocation.prototype, "locationType", {
        get: function () {
            return this._locationType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemLocation.prototype, "left", {
        get: function () {
            return this._left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemLocation.prototype, "top", {
        get: function () {
            return this._top;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemLocation.prototype, "isOpened", {
        get: function () {
            return this._isOpened;
        },
        enumerable: true,
        configurable: true
    });
    ItemLocation.prototype.toggleOpened = function () {
        this._isOpened = !this.isOpened;
    };
    ItemLocation.prototype.isOutside = function () {
        return this._locationType === LocationType.Outside;
    };
    ItemLocation.prototype.isInPit = function () {
        return this._locationType === LocationType.PitEntrance;
    };
    ItemLocation.prototype.isOutOfPit = function () {
        return this._locationType === LocationType.PitExit;
    };
    ItemLocation.prototype.isInSingleEntranceCave = function () {
        return this._locationType === LocationType.Single;
    };
    ItemLocation.prototype.isInMultipleEntranceCave = function () {
        return this._locationType === LocationType.Multiple;
    };
    return ItemLocation;
}());
export { ItemLocation };
